import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import { Subscription } from '../types/membership'

export function getSubscriptions(email: string): AxiosPromise<
	AppApiResponseData<{
		records: Array<Subscription>
	}>
> {
	return http({
		method: 'GET',
		url: `sf/account/${email}/subscriptions`,
	})
}
